import React from 'react'
import './history.scss'
export default function History() {
  return (
    <div>History</div>
  )
}
